import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "icon", "type", "submit", "reset", "isLoading", "loadingText", "fullwidth", "fullheight", "size", "color", "labelText"];
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { iconSize, iconColor, getButtonType } from '../ButtonBase';
import { ButtonStyled, ButtonContent, NoWrap } from './ButtonStyledComponents';
import * as Icons from '../../Icons';
import * as AliasedIcons from '../../Icons/aliases';
var ForwardedButton = /*#__PURE__*/React.forwardRef(function Button(_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      type = _ref.type,
      submit = _ref.submit,
      reset = _ref.reset,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      fullwidth = _ref.fullwidth,
      fullheight = _ref.fullheight,
      size = _ref.size,
      color = _ref.color,
      labelText = _ref.labelText,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = Icons[icon] || AliasedIcons[icon];
  var newIcon;
  var remainingChildren = React.Children.toArray(children).filter(function (item) {
    if (get(item, 'type.isIcon', false)) {
      var _item$props = item.props,
          localColor = _item$props.color,
          localSize = _item$props.size;
      newIcon = /*#__PURE__*/React.cloneElement(item, {
        size: localSize || iconSize(size),
        color: localColor || iconColor(type, color)
      });
      return null;
    }

    return item;
  });
  var withIcon = remainingChildren.length < 1;
  var markup = /*#__PURE__*/React.createElement(NoWrap, null, icon && /*#__PURE__*/React.createElement(Icon, {
    color: iconColor(type, color),
    size: iconSize(size)
  }), newIcon, remainingChildren.length > 0 && /*#__PURE__*/React.createElement(ButtonContent, null, remainingChildren));
  var loadingMarkup = /*#__PURE__*/React.createElement(NoWrap, null, loadingText);
  var ariaProps = {};

  if (labelText) {
    ariaProps = {
      'aria-label': labelText
    };
  }

  return /*#__PURE__*/React.createElement(ButtonStyled, _extends({
    typeStyle: type,
    size: size,
    fullwidth: fullwidth,
    fullheight: fullheight,
    color: color,
    type: getButtonType({
      submit: submit,
      reset: reset
    }),
    withIcon: withIcon,
    ref: ref
  }, ariaProps, props), isLoading ? loadingMarkup : markup);
});
ForwardedButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['primary', 'secondary', 'destroy']),
  fullwidth: PropTypes.bool,
  fullheight: PropTypes.bool,
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  loadingText: PropTypes.node,
  reset: PropTypes.bool,
  submit: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'secondary', 'text', 'white', 'destroy', 'dark']),
  labelText: PropTypes.string
};
ForwardedButton.defaultProps = {
  children: null,
  color: 'primary',
  fullwidth: false,
  fullheight: false,
  icon: null,
  isLoading: false,
  size: null,
  loadingText: '',
  reset: false,
  submit: false,
  type: 'primary',
  labelText: null
};
ForwardedButton.displayName = 'Button';
export default ForwardedButton;